

















































import {
  defineComponent,
  onMounted,
  ref,
  useContext,
} from '@nuxtjs/composition-api';

import HomeCarousel from '~/components/HomeCarousel.vue';
import PromotionActivities from '~/components/Promotion/PromotionActivities.vue';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import { useApi } from '~/composables/useApi';
import { getMetaInfo } from '~/helpers/getMetaInfo';
import { useI18n } from '~/helpers/hooks/usei18n';
import { CmsPage } from '~/modules/GraphQL/types';
import getHomeDataGql from '~/queries/getHomeData.gql';
import getSliderGql from '~/queries/getSlider.gql';
import { Promotion, SliderItem } from '~/queries/types';

export default defineComponent({
  name: 'HomePage',
  components: {
    HomeCarousel,
    LoadWhenVisible,
    PromotionActivities,
    SkeletonLoader,
    CodeOfTheWeekCarousel: () =>
      import(
        /* webpackPrefetch: true */ '~/components/Promotion/CodeOfTheWeekCarousel.vue'
      ),
    NewProducts: () =>
      import(/* webpackPrefetch: true */ '~/components/NewProducts.vue'),
    // ReducedProducts: () =>
    //   import(/* webpackPrefetch: true */ '~/components/ReducedProducts.vue'),
    FeaturedProducts: () =>
      import(/* webpackPrefetch: true */ '~/components/FeaturedProducts.vue'),
    ShopByCategory: () =>
      import(/* webpackPrefetch: true */ '~/components/ShopByCategory.vue'),
  },
  setup() {
    const { query } = useApi();
    const {
      $config: { currentSite },
    } = useContext();
    const page = ref<CmsPage | null>(null);
    const sliders = ref<SliderItem[] | Array<any>>([]);
    const codeSliders = ref<Promotion | any>({ name: '', id: 0, banners: [] });
    const promotions = ref<Promotion>({ name: '', banners: [], id: 0 });
    const newProducts = ref<[] | Array<any>>([]);
    const { locale } = useI18n();

    let sliderId;
    if (locale === 'gb' || currentSite === 'cn') {
      sliderId = 1;
    } else if (locale === 'mex') {
      sliderId = 22;
    } else if (locale === 'us') {
      sliderId = 11;
    } else if (locale === 'aurawest') {
      sliderId = 24;
    }

    // test line

    let codeId;
    if (locale === 'gb' || currentSite === 'cn') {
      codeId = 2;
    } else if (locale === 'mex') {
      codeId = 21;
    } else {
      codeId = 12;
    }

    let promtionId;
    if (locale === 'gb' || currentSite === 'cn') {
      promtionId = 3;
    } else if (locale === 'mex') {
      promtionId = 23;
    } else if (locale === 'us') {
      promtionId = 13;
    }
    // else if (locale === 'aurawest') {
    //   promtionId = 25;
    // }

    const fetchHomeSlidersData = async () => {
      console.log('----- fetchHomeSlidersData --', sliderId);
      if (!sliders.value || sliders.value.length === 0) {
        const { data } = await query<any>(getSliderGql, {
          sliderId,
        });
        sliders.value = data?.slidersData?.banners;
      }
    };
    const fetchHomeData = async () => {
      if (
        codeSliders.value.banners.length === 0 ||
        promotions.value.banners.length === 0
      ) {
        const { data } = await query<any>(getHomeDataGql, {
          codeId,
          promtionId,
        });
        codeSliders.value = data?.codeData;
        promotions.value = data?.promtionData;
      }
    };
    const handlenewProducts = (items) => {
      newProducts.value = items;
    };

    onMounted(async () => {
      await fetchHomeSlidersData();
      await fetchHomeData();
      if (currentSite === 'aurawest') {
        page.value = {
          meta_description:
            'Aura West is based in Texas and operates as an independent provider of authentic fragrances. We are not affiliated with, endorsed by, or connected to any fragrance brand owner or manufacturer. The fragrance contained in this package is 100% authentic, sourced from original products, and has been independently decanted, re-bottled, and packaged by Aura West.',
          meta_keywords: 'Fragrance,100% authentic perfume',
          meta_title: 'Fragrance,100% authentic perfume | AuraWest',
          title: 'Home page',
        } as CmsPage;
      } else {
        page.value = {
          meta_description:
            'Unineed is an UK online fashion and beauty retailer offering products from over 450 brands ranging from skincare to make-up to accessories. Your one-stop shop for all of your beauty and skincare needs.',
          meta_keywords:
            'Beauty,Skincare,Haircare, Make Up, Perfume,Handbags, Watches,Sunglasses, Shaving &amp; Dental Care.',
          meta_title:
            'Luxury Beauty, Skincare, Haircare &amp; Makeup | Unineed',
          title: 'Home page',
        } as CmsPage;
      }

      // addTags([{ prefix: CacheTagPrefix.View, value: 'home' }]);
    });

    // @ts-ignore
    return {
      page,
      sliders,
      codeSliders,
      promotions,
      locale,
      currentSite,
      handlenewProducts,
      newProducts,
    };
  },
  head() {
    return getMetaInfo(this.page);
  },
});
